module.exports = __webpack_public_path__ + "media/images/marker_note-e4df7243.svg";